export enum LaunchStatus {
	LAUNCH_STATE_UNSPECIFIED = 'LAUNCH_STATE_UNSPECIFIED',
	LAUNCH_STATE_UNLAUNCHED = 'LAUNCH_STATE_UNLAUNCHED',
	LAUNCH_STATE_PENDING = 'LAUNCH_STATE_PENDING',
	LAUNCH_STATE_LAUNCHED = 'LAUNCH_STATE_LAUNCHED',
	LAUNCH_STATE_REJECTED = 'LAUNCH_STATE_REJECTED',
	LAUNCH_STATE_SUSPENDED = 'LAUNCH_STATE_SUSPENDED',
	LAUNCH_STATE_PENDING_UNLAUNCH = 'LAUNCH_STATE_PENDING_UNLAUNCH'
}
